export default __webpack_public_path__ + "static/media/ex-contact.fec22b05.jpg";